// Routes that should not be used as redirect targets after authentication
import { AUTH_SCOPES } from './middleware-redirect-helper'

// A utility function to validate redirect URLs to prevent open redirect vulnerabilities.
// If the URL is invalid or unsafe, it defaults to returning the root path '/'.
export const validateRedirectUrl = (url: string | null | undefined): string => {
  try {
    const { pathname, search } = new URL(url || '/', 'https://eversports.com')
    return AUTH_SCOPES.some((path) => pathname.startsWith(path)) ? '/' : [pathname, search].join('')
  } catch {
    return '/'
  }
}
